<template>
    <div class="h-full">
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-1 sm:gap-2 px-4 py-1 justify-items-start items-center bg-primary-default">
            <div class="text-white">
                <div class="font-bold text-xs sm:text-sm line-clamp-1">
                    <span>{{ data.course.name }}</span>
                    <span class="ml-0.5">·</span>
                    <span class="ml-0.5">{{ data.unit.name }}</span>
                </div>
                <h2 class="text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl line-clamp-1">
                    {{ data.title }}
                </h2>
            </div>
            <div class="place-self-end sm:place-self-center grid grid-cols-3 order-last sm:order-2 divide-x divide-white bg-yellow-default font-bold text-sm sm:text-base text-gray-980 rounded-lg shadow-lg text-center border border-primary-default">
                <div v-if="data.results" class="py-1 px-2 sm:px-3">
                    <div>Doğru</div>
                    <div>{{ data.results.correct }}</div>
                </div>
                <div v-if="data.results" class="py-1 px-2 sm:px-3">
                    <div>Yanlış</div>
                    <div>{{ data.results.wrong }}</div>
                </div>
                <div v-if="data.results" class="py-1 px-2 sm:px-3">
                    <div>Boş</div>
                    <div>{{ data.results.empty }}</div>
                </div>
            </div>
            <div class="flex justify-self-end order-2 sm:order-3">
                <button v-if="!data.isFinished" type="button" class="btn btn-secondary" @click="showFinishModal()">
                    TESTİ BİTİR
                </button>
                <a v-else :href="data.unit.url" type="button" class="btn btn-secondary">
                    TESTİ KAPAT
                </a>
            </div>
            <div class="order-3 sm:hidden font-bold text-sm sm:text-lg text-gray-980 bg-yellow-default rounded-xl p-2">
                {{ currentQuestionIndex + 1 }} / {{ data.questions.length }}
            </div>
        </div>
        <div class="w-full p-2 bg-white overflow-y-auto learning-test-content-container" style="height: calc(100vh - 7.5rem);">
            <div class="h-full relative">
                <img class="sm:w-1/2 zoom-out object-contain mx-auto" 
                    :src="data.questions[currentQuestionIndex].question_image_url" 
                    ref="questionImageRef"
                    loading="lazy"
                    decoding="async" />
                <div class="mt-4 mb-2 px-2 sm:px-4 w-full flex items-center justify-between">
                    <button :class="{invisible: data.questions[currentQuestionIndex].is_checked || !data.questions[currentQuestionIndex].hint}" type="button" class="inline-flex items-center btn btn-sm py-1 bg-gray-400 text-primary-default border-2 border-gray-500" @click="getHint()">
                        <svg class="w-6 h-6 fill-current text-primary-default" width="33.372" height="33.372" viewBox="0 0 33.372 33.372"><defs></defs><path class="a" d="M68.986,81.527c.257-.684,1.385-1.089,1.357-1.736s-1.684-.374-2.434-1.5c-.24-.361.8-1.8-.024-1.843-1.874-.095-.393-2.006-.642-2.729-.281-.822-3.273.659-3.88.065-.275-.268-.024-.786-.307-1.14-.328-.412-1.294.636-1.714.211-.516-.527-.25-1.946-.846-2.659-.549-.659-1.923,1.088-2.723,1.073-1.016-.016-.658-.688-2.772-2.024-1.784-1.124-2.632,1.972-3.308,2.024-.95.074-1.868-2.243-2.523-1.586-.712.713-1.12,2.243-1.738,2.767-.5.426-1.528-1.186-1.918-.773-.337.352-.489,1.234-.816,1.5-.725.594-2.836-1.39-3.314-.634-.65,1.032.673,2.935-.9,4.465S37,78.765,37,79.633c0,1.262,1.263,1.566,1.528,3.653.041.321-1.1.673-.921,1.179s.9.748.853,1c-.269,1.341-1.489,2.35-1.235,2.745.72,1.12,2.056,1.22,2.668,1.678,1.115.835.064,1.933.415,2.421a4.528,4.528,0,0,0,2.968,1.523c-.111,1.866.37,3.832,3.825,4.783,2.529.667,1.134,3.752,6.586,3.752s4.053-3.085,6.584-3.752c3.525-.97,3.956-3,3.818-4.9a6.788,6.788,0,0,0,3.153-1.03c.45-.4-.847-1.571.451-2.3.61-.342,2.667-.347,2.667-2.181,0-.489-1.511-1.064-1.54-1.575-.031-.535,1.444-1.648,1.54-2.122C70.55,83.59,68.014,84.118,68.986,81.527ZM47.116,79.77a4.284,4.284,0,0,1,3.155-1.178,12.209,12.209,0,0,1,2.827.762,2.071,2.071,0,0,0,.591.086,2.027,2.027,0,0,0,.589-.087,12.3,12.3,0,0,1,2.827-.761,4.28,4.28,0,0,1,3.154,1.178,8.805,8.805,0,0,1,2.058,5.512l-1.764.922a3.107,3.107,0,0,0-5.63.524H52.453a3.107,3.107,0,0,0-5.63-.524l-1.761-.989A8.76,8.76,0,0,1,47.116,79.77Zm12.359,8a1.616,1.616,0,1,1-1.615-1.616A1.618,1.618,0,0,1,59.475,87.77Zm-8.343,0a1.616,1.616,0,1,1-1.617-1.616A1.618,1.618,0,0,1,51.132,87.77Zm8.6,9.014a4.774,4.774,0,0,0-2.92,2.346c-.578.9-.954,1.332-3.123,1.332s-2.546-.433-3.124-1.332a4.788,4.788,0,0,0-2.941-2.352c-2.621-.722-2.573-1.8-2.214-4.178a8.376,8.376,0,0,0,.143-2.242c-.082-.679-.379-1.953-.487-3.351l1.324.742c0,.006,0,.012,0,.018a3.124,3.124,0,0,0,6.205.521h2.191a3.124,3.124,0,0,0,6.205-.521c0-.006,0-.012,0-.018l1.32-.69c-.111,1.378-.4,2.627-.484,3.3a8.4,8.4,0,0,0,.144,2.243C62.325,94.978,62.372,96.057,59.731,96.784ZM47.244,81.646c.218-.141.316-.788,1.015-.788.881,0,1-.365,1.782-.365a6.583,6.583,0,0,1,.979.217c.387.06.627-.077.89.062.4.218.849.556.707,1.857-.082.745-.855.712-1.868.533-3.157-.557-3.367.524-4.143.431C46.039,83.526,46.688,82,47.244,81.646Zm7.513.983c-.143-1.3.306-1.639.706-1.857.264-.14.5,0,.891-.062a6.583,6.583,0,0,1,.979-.217c.786,0,.9.365,1.782.365.7,0,.8.648,1.015.788.556.352,1.2,1.88.638,1.946-.776.093-.986-.988-4.144-.431C55.612,83.341,54.84,83.374,54.757,82.629ZM58.9,95.949a.213.213,0,0,1-.1.169.219.219,0,0,1-.191.033c-.3-.088-.571-.3-.863-.247-.264.045-.547.336-.892.492-.544.169-1.079-.428-1.57-.428-.726,0-.948.666-1.6.666s-.875-.666-1.6-.666c-.491,0-1.025.6-1.568.428-.346-.156-.629-.447-.892-.492-.291-.05-.56.159-.864.247a.229.229,0,0,1-.289-.2,3.116,3.116,0,0,1,2.35-3.333,8.878,8.878,0,0,1,2.864-.674,8.206,8.206,0,0,1,2.769.674C58.029,92.994,58.9,93.878,58.9,95.949Z" transform="translate(-37.001 -68.998)"/></svg>
                        <span class="ml-2 mt-0.5">YARDIM AL</span>
                    </button>
                    <div>
                        <button v-show="!data.questions[currentQuestionIndex].is_checked" class="btn btn-xs px-2 sm:px-4" type="button" @click="checkAnswer()">
                            {{ data.questions[currentQuestionIndex].answer !== null ? 'KONTROL ET' : 'ÇÖZEMEDİM' }}
                        </button>
                        <button v-show="data.questions[currentQuestionIndex].is_checked && data.questions[currentQuestionIndex].solution_video_url" class="btn btn-xs px-2 sm:px-4" type="button" @click="showSolution()">
                            ÇÖZÜMÜ GÖSTER
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="absolute bottom-0 left-0 right-0 h-14 bg-background flex justify-center xs:justify-between items-center">
            <div class="hidden sm:block ml-4 font-bold text-lg text-gray-980 bg-yellow-default rounded-xl p-2 px-3">
                {{ currentQuestionIndex + 1 }} / {{ data.questions.length }}
            </div>
            <div class="flex justify-between items-center">
                <div class="back-button-container mr-2 3xs:mr-4 lg:mr-8">
                    <button type="button" class="btn btn-yellow btn-xs sm:px-4 xl:px-8" @click="previousQuestion()">
                        <svg class="w-4 h-4 fill-current text-gray-980" viewBox="0 0 32 32">
                            <path d="M 19.75 2.59375 L 19.03125 3.28125 L 7.03125 15.28125 L 6.34375 16 L 7.03125 16.71875 L 19.03125 28.71875 L 19.75 29.40625 L 20.46875 28.71875 L 24.0625 25.09375 L 24.75 24.40625 L 24.0625 23.6875 L 16.375 16 L 24.0625 8.3125 L 24.75 7.59375 L 24.0625 6.90625 L 20.46875 3.28125 Z M 19.75 5.4375 L 21.9375 7.625 L 14.25 15.28125 L 13.53125 16 L 14.25 16.71875 L 21.9375 24.375 L 19.75 26.5625 L 9.1875 16 Z"></path>
                        </svg>
                    </button>
                </div>
                <div class="flex space-x-1 sm:space-x-2 items-center">
                    <button type="button" class="answer-btn"
                            :class="{selected: i === data.questions[currentQuestionIndex].answer,
                            checked: data.questions[currentQuestionIndex].is_checked,
                            correct: data.questions[currentQuestionIndex].is_checked && i === data.questions[currentQuestionIndex].correct_answer,
                            wrong: data.questions[currentQuestionIndex].is_checked && i !== data.questions[currentQuestionIndex].correct_answer && i === data.questions[currentQuestionIndex].answer}"
                            v-for="(i) in Array(data.answerCount).keys()"
                            @click="!data.questions[currentQuestionIndex].is_checked && saveAnswer(i)">
                        {{ String.fromCharCode(i + 65) }}
                    </button>
                </div>
                <div class="forward-button-container ml-2 3xs:ml-4 lg:ml-8">
                    <button type="button" class="btn btn-yellow btn-xs sm:px-4 xl:px-8" @click="nextQuestion()">
                        <svg class="w-4 h-4 fill-current text-gray-980" viewBox="0 0 32 32">
                            <path d="M 12.25 2.59375 L 11.53125 3.28125 L 7.9375 6.90625 L 7.25 7.59375 L 7.9375 8.3125 L 15.625 16 L 7.9375 23.6875 L 7.25 24.40625 L 7.9375 25.09375 L 11.53125 28.71875 L 12.25 29.40625 L 12.96875 28.71875 L 24.96875 16.71875 L 25.65625 16 L 24.96875 15.28125 L 12.96875 3.28125 Z M 12.25 5.4375 L 22.8125 16 L 12.25 26.5625 L 10.0625 24.375 L 17.75 16.71875 L 18.46875 16 L 17.75 15.28125 L 10.0625 7.625 Z"></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="hidden xs:flex mr-4">
                <button type="button" class="btn btn-sm btn-yellow" @click="zoom()">
                    <svg v-show="!isZoomed" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"></path>
                    </svg>
                    <svg v-show="isZoomed" class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"></path>
                    </svg>
                </button>
            </div>
        </div>
        <div v-show="isLoading" class="absolute w-full h-full top-1/2 left-1/2 text-center bg-black bg-opacity-10 z-10" style="transform: translate(-50%,-50%)">
            <div class="w-full h-full flex items-center justify-center">
                <pulse-loader :color="'#03B0B9'" :size="'12px'"></pulse-loader>
            </div>
        </div>
    </div>
    <SolutionVideoModal ref="solutionModalRef"></SolutionVideoModal>
    <HintModal ref="hintModalRef"></HintModal>
    <FinishModal ref="finishModalRef" :unitUrl="data.unit.url" :totalQuestionCount="data.questions.length" :finishTest="finishTest"></FinishModal>
    <ResultsModal ref="resultsModalRef"></ResultsModal>
</template>

<script setup>
    import {onMounted, reactive, ref} from "vue";
    import SolutionVideoModal from "./modal/SolutionVideoModal.vue";
    import HintModal from "./modal/HintModal.vue";
    import FinishModal from "./modal/FinishModal.vue";
    import ResultsModal from "./modal/ResultsModal.vue";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import { useToast } from "vue-toastification";
    import Toast from "../components/toast/learning/Toast.vue";
    import HappyIcon from "../components/toast/icon/HappyIcon.vue";
    import SadIcon from "../components/toast/icon/SadIcon.vue";
    import InfoIcon from "../components/toast/icon/InfoIcon.vue";

    const props = defineProps(['test', 'user']);
    const data = reactive(props.test);
    const user = reactive(props.user);
    const isLoading = ref(false);
    const isZoomed = ref(false);
    const questionImageRef = ref(null);
    const currentQuestionIndex = ref(0);
    const solutionModalRef = ref(null);
    const hintModalRef = ref(null);
    const finishModalRef = ref(null);
    const resultsModalRef = ref(null);
    const toast = useToast();

    onMounted(() => {
        let notCheckedQuestions = data.questions.filter((q) => !q.is_checked);
        if (notCheckedQuestions.length > 0) {
            loadQuestion(notCheckedQuestions.shift().no);
        } else {
            loadQuestion(0);
        }

        document.getElementsByTagName("body")[0].oncontextmenu = function(e){ e.preventDefault(); }
    });

    const loadQuestion = (i) => {
        currentQuestionIndex.value = i;
    }

    const nextQuestion = () => {
        if (currentQuestionIndex.value < data.questions.length - 1) {
            loadQuestion(currentQuestionIndex.value + 1);
        }
    }

    const previousQuestion = () => {
        if (currentQuestionIndex.value > 0) {
            loadQuestion(currentQuestionIndex.value - 1);
        }
    }

    const showSolution = () => {
        if (data.questions[currentQuestionIndex.value].solution_video_url) {
            solutionModalRef.value.videoUrl = data.questions[currentQuestionIndex.value].solution_video_url;
            solutionModalRef.value.isModalOpen = true;
        }
    }

    const showHint = () => {
        if (typeof data.questions[currentQuestionIndex.value].hint === 'string') {
            hintModalRef.value.hint = data.questions[currentQuestionIndex.value].hint;
            hintModalRef.value.isModalOpen = true;
        }
    }

    const zoom = () => {
        if (isZoomed.value) {
            questionImageRef.value.classList.add('zoom-out');
        } else {
            questionImageRef.value.classList.remove('zoom-out');
        }

        isZoomed.value = !isZoomed.value;
    }

    const showFinishModal = () => {
        finishModalRef.value.remainingQuestionCount = data.questions.filter((q) => q.answer === null && !q.is_checked).length;
        finishModalRef.value.isModalOpen = true;
    }

    const saveAnswer = (i) => {
        let newAnswer = data.questions[currentQuestionIndex.value].answer !== i ? i : null;

        isLoading.value = true;

        axios.post("/api/test/cevap-kaydet", {
            testId: data.id,
            questionId: data.questions[currentQuestionIndex.value].id,
            answer: newAnswer
        }).then((response) => {
            if (response.data.error === "") {
                data.questions[currentQuestionIndex.value].answer = newAnswer;
            }
        }).catch((error) => {

        }).then(() => {
            isLoading.value = false;
        });
    }

    const checkAnswer = () => {
        isLoading.value = true;

        axios.post("/api/test/cevap-kontrol", {
            testId: data.id,
            questionId: data.questions[currentQuestionIndex.value].id,
            answer: data.questions[currentQuestionIndex.value].answer
        }).then((response) => {
            if (response.data.error === "") {
                data.questions[currentQuestionIndex.value].correct_answer = response.data.data.question.correct_answer;
                data.questions[currentQuestionIndex.value].is_checked = true;
                data.questions[currentQuestionIndex.value].solution_video_url = response.data.data.question.solution_video_url;

                if (response.data.data.question.already_checked === true) {
                    data.questions[currentQuestionIndex.value].answer = response.data.data.question.student_answer;

                    toast({
                        component: Toast,
                        props: {
                            type: 'info',
                            content: 'Bu soruyu daha önceden cevapladın.'
                        }
                    }, {
                        type: 'warning',
                        timeout: 3000,
                        icon: InfoIcon
                    });
                } else {
                    if (data.questions[currentQuestionIndex.value].answer == data.questions[currentQuestionIndex.value].correct_answer) {
                        toast({
                            component: Toast,
                            props: {
                                type: 'success',
                                content: 'Soruyu doğru cevapladın, tebrikler!'
                            }
                        }, {
                            type: 'success',
                            timeout: 3000,
                            icon: HappyIcon
                        });
                    } else if (data.questions[currentQuestionIndex.value].answer !== null) {
                        toast({
                            component: Toast,
                            props: {
                                type: 'wrong',
                                content: 'Soruyu maalesef yanlış cevapladın.'
                            }
                        }, {
                            type: 'error',
                            timeout: 3000,
                            icon: SadIcon
                        });
                    }
                }

                if (data.questions.filter((q) => q.is_checked).length === data.questions.length) {
                    finishTest();
                }
            }
        }).catch((error) => {
            if (error.response.data.error === 'Çözülmüş Test') {
                finishTest();
            }
        }).then(() => {
            isLoading.value = false;
        });
    }

    const getHint = () => {
        if (data.questions[currentQuestionIndex.value].hint === true) {
            isLoading.value = true;

            axios.post("/api/test/ipucu", {
                testId: data.id,
                questionId: data.questions[currentQuestionIndex.value].id,
            }).then((response) => {
                if (response.data.error === "") {
                    data.questions[currentQuestionIndex.value].hint = response.data.data.hint;
                }
            }).catch((error) => {

            }).then(() => {
                isLoading.value = false;
                showHint();
            });
        }

        showHint();
    }

    const finishTest = () => {
        finishModalRef.value.isModalOpen = false;
        isLoading.value = true;

        axios.post("/api/test/bitir", {
            testId: data.id,
            answers: data.questions.map((q) => {return {questionId: q.id, answer: q.answer}})
        }).then((response) => {
            if (response.data.error === "") {
                // Check answers
                for (let i = 0; i < response.data.data.questions.length; ++i) {
                    if (user.type === 2 && response.data.data.questions[i].answer !== data.questions[i].answer) {
                        data.questions[i].answer = response.data.data.questions[i].answer;
                    }
                    data.questions[i].correct_answer = response.data.data.questions[i].correct_answer;
                    data.questions[i].is_checked = true;
                    data.questions[i].solution_video_url = response.data.data.questions[i].solution_video_url;
                }

                // Show results modal
                resultsModalRef.value.results = response.data.data.results;
                resultsModalRef.value.isModalOpen = true;

                data.results = response.data.data.results;
                data.isFinished = true;
            }
        }).catch((error) => {

        }).then(() => {
            isLoading.value = false;
        });
    }
</script>
